import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from '../Pages/Home';
import Tours from '../Pages/Tours';
import TourDetails from '../Pages/TourDetails';
import Login from '../Pages/Login';
import Register from '../Pages/Register';
import SearchResultList from '../Pages/SearchResultList';
import ThankYou from '../Pages/ThankYou';
import About from '../Pages/About';
import FAQ from '../Shared/FAQ';
import Contact from '../Pages/Contact';
import Gallery from '../Pages/Gallery';
import PageNotFound from '../Pages/PageNotFound';
import Blogs from '../Pages/Blogs';
import BlogDetails from '../Pages/BlogDetails';
import ScrollToTop from '../utils/scrolltoTop';

// Admin Components
import AdminLogin from '../Admin/AdminLogin';
import AdminLayout from '../Admin/AdminLayout';
import AdminDashboard from '../Admin/AdminDashboard';
import TourManagement from '../Admin/TourManagement';
import AddEditTour from '../Admin/AddEditTour';
import BookingsManagement from '../Admin/BookingsManagement';
import ContactsManagement from '../Admin/ContactsManagement';
import BlogsManagement from '../Admin/BlogsManagement';
import AddEditBlog from '../Admin/AddEditBlog';
import NewsletterManagement from '../Admin/NewsletterManagement';
import UsersManagement from '../Admin/UsersManagement';
import ProtectedRoute from '../Admin/ProtectedRoute';

const Router = () => {
  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/tours" element={<Tours />} />
        <Route path="/tours/:id" element={<TourDetails />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/search" element={<SearchResultList />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blogs/:id" element={<BlogDetails />} />

        {/* Admin Routes */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <AdminDashboard />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/tours"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <TourManagement />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/tours/add"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <AddEditTour />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/tours/edit/:id"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <AddEditTour />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/bookings"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <BookingsManagement />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/contacts"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <ContactsManagement />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/blogs"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <BlogsManagement />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/blogs/add"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <AddEditBlog />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/blogs/edit/:id"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <AddEditBlog />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/users"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <UsersManagement />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/newsletter"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <NewsletterManagement />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<PageNotFound />} />
      </Routes></>
  );
};

export default Router;
